import $ from 'jquery';

// Keeps a selected option image reachable after the shopper browses the PDP
// gallery. BigCommerce resolves the variant and updates the first main slide;
// this module mirrors that canonical image into the first thumbnail and makes a
// second click on the selected color return to it.

function getSlideImage($slide) {
    return $slide.is('img') ? $slide : $slide.find('img').first();
}

function getSelectedSwatchName($productView) {
    let selectedName = '';

    $productView.find('label.form-option-swatch').each(function () {
        const input = document.getElementById($(this).attr('for'));

        if (input && input.checked) {
            selectedName = $.trim($(this).find('[title]').first().attr('title') || $(this).text());
            return false;
        }

        return true;
    });

    return selectedName;
}

export function makeThumbnailsAccessible($productView) {
    const $slides = $productView.find('.slider-nav .slick-slide').not('.slick-cloned');

    $slides.each(function (index) {
        const $slide = $(this);
        const $image = getSlideImage($slide);
        const description = $.trim($image.attr('alt') || $image.attr('title') || '');
        let label = `View product image ${index + 1}`;

        if (description) {
            label += `: ${description}`;
        }

        $slide.attr({
            'aria-label': label,
            role: 'button',
            tabindex: $slide.hasClass('slick-active') ? '0' : '-1',
        });
    });
}

export function selectThumbnailImage($thumbnailSlide) {
    const $productView = $thumbnailSlide.closest('.productView');
    const $mainSlider = $productView.find('.slider-for').first();
    const slideIndex = parseInt($thumbnailSlide.attr('data-slick-index'), 10);

    if (!$mainSlider.hasClass('slick-initialized') || Number.isNaN(slideIndex) || slideIndex < 0) {
        return;
    }

    $mainSlider.slick('slickGoTo', slideIndex, true);

    window.requestAnimationFrame(() => {
        const $selectedSlide = $mainSlider.find(`.slick-slide[data-slick-index="${slideIndex}"]`)
            .not('.slick-cloned')
            .first();
        const $selectedFigure = $selectedSlide.find('figure.productView-image').first();
        const $selectedImage = getSlideImage($selectedSlide);
        const imageUrl = $selectedFigure.attr('data-image-gallery-new-image-url')
            || $selectedFigure.attr('data-image-gallery-zoom-image-url')
            || $selectedImage.attr('src')
            || $selectedImage.attr('data-src');

        if (imageUrl) {
            $selectedFigure.attr({
                'data-image-gallery-main': imageUrl,
                'data-image-gallery-zoom-image-url': imageUrl,
                'data-zoom-image': imageUrl,
                href: imageUrl,
            });
        }

        makeThumbnailsAccessible($productView);
    });
}

export function syncVariantThumbnail($productView) {
    const $mainFirstSlide = $productView.find('.slider-for .slick-slide[data-slick-index="0"]')
        .not('.slick-cloned')
        .first();
    const $mainImage = getSlideImage($mainFirstSlide);
    const variantImageUrl = $mainImage.attr('src') || $mainImage.attr('data-src');
    const $thumbnailSlide = $productView.find('.slider-nav .slick-slide[data-slick-index="0"]')
        .not('.slick-cloned')
        .first();
    const $thumbnailImage = getSlideImage($thumbnailSlide);
    const selectedSwatchName = getSelectedSwatchName($productView);

    if (!variantImageUrl || !$thumbnailImage.length) {
        makeThumbnailsAccessible($productView);
        return;
    }

    $thumbnailImage.attr('src', variantImageUrl);
    if (selectedSwatchName) {
        $thumbnailImage.attr({
            alt: `${selectedSwatchName} product image`,
            title: `${selectedSwatchName} product image`,
        });
    }

    makeThumbnailsAccessible($productView);
}

export function restoreSelectedVariantImage($productView) {
    const $mainSlider = $productView.find('.slider-for').first();
    const $mainFirstSlide = $mainSlider.find('.slick-slide[data-slick-index="0"]')
        .not('.slick-cloned')
        .first();
    const $sourceImage = getSlideImage($mainFirstSlide);
    const variantImageUrl = $sourceImage.attr('src') || $sourceImage.attr('data-src');

    if (!variantImageUrl || !$mainSlider.hasClass('slick-initialized')) {
        return;
    }

    $mainSlider.slick('slickGoTo', 0, true);

    window.requestAnimationFrame(() => {
        const $activeFigure = $mainSlider.find('.slick-current figure.productView-image').first();
        const $activeImage = $activeFigure.find('img').first();

        $activeFigure.attr({
            'data-image-gallery-main': variantImageUrl,
            'data-image-gallery-new-image-url': variantImageUrl,
            'data-image-gallery-zoom-image-url': variantImageUrl,
            'data-zoom-image': variantImageUrl,
            href: variantImageUrl,
        });
        $activeImage.attr('src', variantImageUrl);
        syncVariantThumbnail($productView);
    });
}

function initializeProductView($productView) {
    const $mainSlider = $productView.find('.slider-for').first();

    if (!$mainSlider.length || $productView.data('h4hVariantThumbnailSync')) {
        return;
    }

    $productView.data('h4hVariantThumbnailSync', true);

    if (window.MutationObserver) {
        const observer = new window.MutationObserver(() => syncVariantThumbnail($productView));

        observer.observe($mainSlider.get(0), {
            attributes: true,
            attributeFilter: ['src', 'data-src'],
            childList: true,
            subtree: true,
        });
    }

    $mainSlider.add($productView.find('.slider-nav'))
        .on('afterChange setPosition reInit', () => makeThumbnailsAccessible($productView));

    syncVariantThumbnail($productView);
}

export default function initializePdpVariantThumbnailSync() {
    $('.productView').each(function () {
        initializeProductView($(this));
    });

    $(document)
        .off('.h4hPdpVariantThumbnail')
        .on('click.h4hPdpVariantThumbnail', '.productView label.form-option-swatch', function () {
            const input = document.getElementById($(this).attr('for'));

            // A label's click handler runs before its radio's default activation.
            // If it is already checked here, the shopper re-clicked that color.
            if (input && input.checked) {
                restoreSelectedVariantImage($(this).closest('.productView'));
            }
        })
        .on('click.h4hPdpVariantThumbnail', '.productView .slider-nav .slick-slide:not(.slick-cloned)', function () {
            selectThumbnailImage($(this));
        })
        .on('keydown.h4hPdpVariantThumbnail', '.productView .slider-nav .slick-slide[role="button"]', function (event) {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                selectThumbnailImage($(this));
            }
        });
}
